import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { BuscarParametroPorTipoGQL } from 'src/app/generated/graphql';

@Injectable({
  providedIn: 'root'
})
export class PaginacaoService {
  private paginationSubject: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  public pagination$: Observable<number | null> = this.paginationSubject.asObservable();

  private static readonly MIN_PAGINATION = 2000;

  constructor(
    private valorParametroPorTipo: BuscarParametroPorTipoGQL
  ) {
    this.getPagination();
  }

  private getPagination() {
    this.valorParametroPorTipo.fetch({
      tipo: 'PAGINACAO_EXPORTACAO'
    }).subscribe({
      next: rs => {
        const data = rs.data.buscarParametroPorTipo;
        if (data?.valor) {
          let pagination = parseInt(data.valor);
          this.paginationSubject.next(pagination);
        }
      }
    });
  }

  public refresh() {
    this.getPagination();
  }
}
